import ClipboardJS from "clipboard";
import JQuery from "jquery";
import tippy, { Instance, Placement } from "tippy.js";

class CopyToClipboard {
  private readonly elements: JQuery<HTMLElement>;
  private readonly beforeMessage: string;
  private readonly afterMessage: string;

  private clipboards: Map<HTMLElement, ClipboardJS>;

  constructor(
    elements: string,
    withTooltip = true,
    duration: number | [number, number] = [500, 750],
  ) {
    this.elements = $(elements);
    if (this.elements.length === 0) {
      return;
    }
    this.clipboards = new Map<HTMLElement, ClipboardJS>();
    this.beforeMessage = this.elements[0].dataset.originalTitle;
    this.afterMessage = this.elements[0].dataset.after;
    for (let i = 0; i < this.elements.length; i += 1) {
      this.addClipboard(this.elements[i], withTooltip, duration);
    }
  }

  private addClipboard(
    element: HTMLElement,
    withTooltip: boolean,
    duration: number | [number, number],
  ): void {
    const clipboard = new ClipboardJS(element);
    const { placement } = element.dataset;
    if (withTooltip) {
      const tooltip = tippy(element, {
        content: this.beforeMessage,
        placement: placement as Placement,
        animation: "shift-away-extreme",
        duration: duration,
        allowHTML: true,
        theme: "nanomonx",
        touch: ["hold", 25],
        hideOnClick: false,
        onHidden: (instance: Instance) => {
          instance.setProps({
            content: this.beforeMessage,
          });
        },
      });

      clipboard.on("success", (event) => {
        tooltip.setProps({
          content: this.afterMessage,
        });
        event.clearSelection();
      });
    }

    this.clipboards.set(element, clipboard);
  }
}

export default CopyToClipboard;
